import { JOB_OPPORTUNITY_STATUSES } from "lookup";

export const getJobOrganization = (jobOpp = {}) => {
  return jobOpp?.organization || "";
};

export const formatJobStatus = (status) => {
  let txt = status;

  switch (status) {
    case JOB_OPPORTUNITY_STATUSES.PENDINGAPPROVAL:
      txt = "PENDING";
      break;
    default:
      txt = status;
      break;
  }

  return txt;
};

const UNSAFE_SFDC_URL_PATTERNS = JSON.parse(
  process.env.REACT_APP_SFDC_URL_PATTERNS || "{}"
);
const randstadDigitalUrlPatterns = {
  jobOpportunity: "",
  ...UNSAFE_SFDC_URL_PATTERNS,
};

export const generateJobExternalLink = (id, type = "jobOpportunity") => {
  const isIDValid = id && typeof id === "string";
  const isTypeValid =
    type && typeof type === "string" && type === "jobOpportunity";
  if (!isIDValid || !isTypeValid) return "";
  return replaceExternalIDFromString(randstadDigitalUrlPatterns?.[type], id);
};

const replaceExternalIDFromString = (str, id) => {
  return str.replace("{!EXTERNALID}", id);
};
